var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccomodationInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 30.3333H2.66669C2.12002 30.3333 1.66669 29.88 1.66669 29.3333C1.66669 28.7866 2.12002 28.3333 2.66669 28.3333H29.3334C29.88 28.3333 30.3334 28.7866 30.3334 29.3333C30.3334 29.88 29.88 30.3333 29.3334 30.3333Z",
    fill: "#1577DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28 13.3067V29.3333H3.93335L4.00002 13.2933C4.00002 12.48 4.37335 11.7067 5.02668 11.2L14.36 3.94671C15.32 3.18671 16.68 3.18671 17.64 3.94671L19.4267 5.33335L25.3333 9.92002L26.9734 11.2C27.6267 11.7067 28 12.48 28 13.3067Z",
    fill: "#1577DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 22.6667H14.6667C13.56 22.6667 12.6667 23.56 12.6667 24.6667V29.3334H19.3334V24.6667C19.3334 23.56 18.44 22.6667 17.3334 22.6667Z",
    fill: "#1577DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 18.3334H10C9.26669 18.3334 8.66669 17.7334 8.66669 17V15C8.66669 14.2667 9.26669 13.6667 10 13.6667H12.6667C13.4 13.6667 14 14.2667 14 15V17C14 17.7334 13.4 18.3334 12.6667 18.3334Z",
    fill: "#1577DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.3334H19.3333C18.6 18.3334 18 17.7334 18 17V15C18 14.2667 18.6 13.6667 19.3333 13.6667H22C22.7333 13.6667 23.3333 14.2667 23.3333 15V17C23.3333 17.7334 22.7333 18.3334 22 18.3334Z",
    fill: "#1577DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 9.91998L19.4266 5.33331H23.9733C24.7066 5.33331 25.3066 5.91997 25.3066 6.6533L25.3333 9.91998Z",
    fill: "#1577DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodationInfo);
export default __webpack_public_path__ + "static/media/AccomodationInfo.8b0f85e824a7fc2221e7579115224f23.svg";
export { ForwardRef as ReactComponent };